import { useState, useEffect, useRef } from 'react';

export const useTTSSubtitles = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentText, setCurrentText] = useState('');
  const [isAnimationActive, setIsAnimationActive] = useState(false);
  
  // Track timeout IDs to prevent leaks on unmount
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    // Set up TTS callbacks when component mounts
    const setupTTSCallbacks = () => {
      if (window.elevenLabsTTS) {
        window.elevenLabsTTS.setAnimationCallbacks(
          // On speaking start
          (text) => {
            console.log('🎬 TTS Speaking started:', text);
            setCurrentText(text);
            setIsVisible(true);
            setIsAnimationActive(true);
          },
          // On speaking end
          () => {
            console.log('🎬 TTS Speaking ended');
            setIsAnimationActive(false);
            // Keep subtitles visible for a bit after speaking ends
            // Clear any existing timeout first
            if (hideTimeoutRef.current) {
              clearTimeout(hideTimeoutRef.current);
            }
            hideTimeoutRef.current = setTimeout(() => {
              setIsVisible(false);
              setCurrentText('');
              hideTimeoutRef.current = null;
            }, 1000);
          }
        );
      }
    };

    // Set up callbacks immediately if TTS is available
    setupTTSCallbacks();

    // Also set up callbacks when TTS becomes available
    const checkTTSInterval = setInterval(() => {
      if (window.elevenLabsTTS && !window.elevenLabsTTS.onSpeakingStart) {
        setupTTSCallbacks();
        clearInterval(checkTTSInterval);
      }
    }, 1000);

    // Cleanup
    return () => {
      clearInterval(checkTTSInterval);
      // Clear any pending hide timeout
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      if (window.elevenLabsTTS) {
        window.elevenLabsTTS.setAnimationCallbacks(null, null);
      }
    };
  }, []);

  // Manual control functions
  const showSubtitles = (text) => {
    setCurrentText(text);
    setIsVisible(true);
  };

  const hideSubtitles = () => {
    setIsVisible(false);
    setCurrentText('');
  };

  const toggleAnimation = (active) => {
    setIsAnimationActive(active);
  };

  return {
    isVisible,
    currentText,
    isAnimationActive,
    showSubtitles,
    hideSubtitles,
    toggleAnimation
  };
};
